/*
 * @Author: liyxt
 * @Date: 2020-05-28 11:40:24
 * @LastEditors: liyxt
 * @LastEditTime: 2020-05-28 14:47:02
 * @Description: file content
 */
import React, { Component } from 'react';
//import OriginForm from 'bee-form';
import { Form as OriginForm } from '@tinper/next-ui';

//require('bee-form/build/Form.css');
require('./index.less');
// 这个组件  从可这边使用了

/**
 * @namespace BaseForm
 */

/**
 * Form组件的参数描述
 * @memberof BaseForm
 * @component Form
 * @property {FormInstance}  form - 经 Form.useForm() 创建的 form 控制实例，不提供时会自动创建
 * @property {object} initialValues - 表单默认值，只有初始化以及重置时生效
 * @property {string} [labelAlign=right] - label 标签的文本对齐方式, 可选值有 left | right
 * @property {boolean} [labelWrap=false] - label 标签的文本换行方式
 * @property {object} labelCol - label 标签布局，同 Col 组件，设置 span offset 值，如 {span: 3, offset: 12} 或 sm: {span: 3, offset: 12}
 * @property {string} [layout=horizontal] - 表单布局，可选值有 horizontal | vertical | inline
 * @property {string} name - 表单名称，会作为表单字段 id 前缀使用
 * @property {boolean | optional} [requiredMark=true] - 必选样式，可以切换为必选或者可选展示样式。此为 Form 配置，Form.Item 无法单独配置
 * @property {boolean | Options} [scrollToFirstError=true] - 提交失败自动滚动到第一个错误字段
 * @property {ValidateMessages} validateMessages - 验证提示模板，说明[见下]
 * @property {string | array<string>} [validateTrigger=onChange] - 统一设置字段触发验证的时机
 * @property {array<object>} wrapperCol - 需要为输入控件设置布局样式时，使用该属性，用法同 labelCol
 * @property {function(changedFields, allFields): void} onFieldsChange - 字段更新时触发回调事件
 * @property {function(values): void} onFinish - 提交表单且数据验证成功后回调事件
 * @property {function({ values, errorFields, outOfDate }): void} onFinishFailed - 提交表单且数据验证失败后回调事件
 * @property {function(changedValues, allValues): void} onValuesChange - 字段值更新时触发回调事件
 */
class Form extends Component {
	render() {
		return <OriginForm {...this.props} />;
	}
}

/**
 * 表单字段组件，用于数据双向绑定、校验、布局等。
 * Item组件的参数描述
 * @memberof BaseForm
 * @component Item
 * @property {boolean} [colon=true] - 配合 label 属性使用，表示是否显示 label 后面的冒号
 * @property {ReactNode} extra  - 额外的提示信息，和 help 类似，当需要错误信息和提示文案同时出现时，可以使用这个。
 * @property {function(...args): any} getValueFromEvent - 设置如何将 event 的值转换成字段值
 * @property {function(value:any): any} getValueProps - 为子元素添加额外的属性
 * @property {boolean} [hasFeedback=false] - 配合 validateStatus 属性使用，展示校验状态图标，建议只配合 Input 组件使用
 * @property {ReactNode} help - 提示信息，如不设置，则会根据校验规则自动生成
 * @property {string} htmlFor - 设置子元素 label htmlFor 属性
 * @property {string} initialValue - 设置子元素默认值，如果与 Form 的 initialValues 冲突则以 Form 为准
 * @property {ReactNode} label - label 标签的文本
 * @property {string} [labelAlign=right] - label 标签的文本，可选值 left | right
 * @property {object} labelCol - label 标签布局，同 Col 组件，设置 span offset 值，如 {span: 3, offset: 12} 或 sm: {span: 3, offset: 12}。你可以通过 Form 的 labelCol 进行统一设置，，不会作用于嵌套 Item。当和 Form 同时设置时，以 Item 为准
 * @property {Record<string, string>} messageVariables - 默认验证字段的信息
 * @property {NamePath|array<NamePath>} name - 字段名，支持数组
 * @property {function(value, prevValue, prevValues): any} normalize - 组件获取值后进行转换，再放入 Form 中。不支持异步
 * @property {boolean} [noStyle=false] - 为 true 时不带样式，作为纯字段控件使用
 * @property {boolean} [required=false] - 必填样式设置。如不设置，则会根据校验规则自动生成
 * @property {array<Rule>} rules - 必填样式设置。如不设置，则会根据校验规则自动生成
 * @property {ReactNode | TooltipProps} tooltip - 配置提示信息
 * @property {string} [trigger=onChange] - 设置收集字段值变更的时机，可选项为表单组件支持的回调函数
 * @property {boolean | 'parallel'} [validateFirst=false] - 当某一规则校验不通过时，是否停止剩下的规则的校验。设置 parallel 时会并行校验
 * @property {string} validateStatus - 校验状态，如不设置，则会根据校验规则自动生成，可选：'success' 'warning' 'error' 'validating'
 * @property {string|array<string>} [validateTrigger=onChange] - 设置字段校验的时机
 * @property {string} [valuePropName=value] - 子节点的值的属性，如 Switch 的是 'checked'。该属性为 getValueProps 的封装，自定义 getValueProps 后会失效
 * @property {object} wrapperCol - 需要为输入控件设置布局样式时，使用该属性，用法同 labelCol。你可以通过 Form 的 wrapperCol 进行统一设置，不会作用于嵌套 Item。当和 Form 同时设置时，以 Item 为准
 */
class Item extends Component {
	render() {
		let { label, labelName, ...others } = this.props;
		return <OriginForm.Item label={label || labelName} {...others} />;
	}
}

Form.FormItem = Item;
Form.Item = Item;
Form.createForm = OriginForm.createForm;
Form.useForm = OriginForm.useForm;
export default Form;
